interface CircleStatusProps {
  color: string
}

const CircleStatus: React.FC<CircleStatusProps> = props => {
  const { color } = props

  return (
    <div
      style={{ backgroundColor: `${color}` }}
      className={`size-4 rounded-full`}
    />
  )
}

export default CircleStatus
